export default function SoftwareStub({ title }: { title: string }) {
  return (
    <div className="prose">
      <h2>{title}</h2>
      <p className="stub-note">Documentation for this section is coming soon.</p>
    </div>
  )
}
